<template>
  <el-tabs v-model="queryParams.walletType" class="fund-tabs" type="border-card" @tab-click="bindTabClick">
    <el-tab-pane v-for="(item, index) in assetTabs" :key="index" :label="item.text" :name="item.name">
      <el-table v-if="item.name === queryParams.walletType" :data="list" stripe fit highlight-current-row height="455" header-cell-class-name="table-header-cell">
        <el-table-column label="序号" width="60" align="center" type="index" fixed class-name="table-header-cell">
          <template slot-scope="scope">
            <span>{{ (scope.$index + 1) + (queryParams.page - 1) * queryParams.limit }}</span>
          </template>
        </el-table-column>
        <el-table-column label="时间" prop="createTime" width="150" />
        <el-table-column label="备注说明" prop="remark" min-width="120" />
        <el-table-column label="数量" prop="amount" width="80" align="right">
          <template slot-scope="{row}">
            <span v-if="row.transactionType === 2" class="text-bold text-red">-{{ row.amount }}</span>
            <span v-else class="text-bold">+{{ row.amount }}</span>
          </template>
        </el-table-column>
      </el-table>
      <pagination :total="total" :page.sync="queryParams.page" :limit.sync="queryParams.limit" layout="total, sizes, prev, pager, next" @pagination="fetchData" />
    </el-tab-pane>
  </el-tabs>
</template>

<script>
import { getAssetsDetail } from '@/api/member'
import Pagination from '@/components/Pagination'

export default {
  name: 'UserFund',
  components: { Pagination },
  props: {
    memberId: {
      type: [Number, String],
      default: ''
    }
  },
  data() {
    return {
      list: [],
      total: 0,
      loading: false,
      assetTabs: [
        { name: 'signin', text: '签到积分' },
        { name: 'subsidy', text: '补贴积分' },
        { name: 'transfer', text: '购物积分' },
        { name: 'coupon', text: '消费券' },
        { name: 'surprise', text: '购物惊喜' },
        { name: 'credit', text: '借入资产' },
        { name: 'loaned', text: '借出资产' }
      ],
      queryParams: {
        walletType: 'signin',
        memberId: '',
        page: 1,
        limit: 10
      }
    }
  },
  mounted() {
    this.queryParams = Object.assign({}, this.queryParams, {
      memberId: this.memberId
    })
    this.fetchData()
  },
  methods: {
    bindTabClick() {
      this.queryParams = Object.assign({}, this.queryParams, { page: 1 })
      this.fetchData()
    },
    fetchData() {
      getAssetsDetail(this.queryParams).then(response => {
        this.list = response.records
        this.total = response.total
      }).catch(() => {})
    }
  }
}
</script>

<style lang="scss" scoped>
  .fund-tabs {
    ::v-deep {
      .el-tabs__content {
        padding: 0;
      }
      .pagination-container {
        margin-top: 20px;
        padding: 0 10px 20px;
      }
    }
  }
  .text-bold {
    font-weight: 600;
  }
  .text-red {
    color: #e54d42;
  }
</style>
